
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.244 9.985A6.022 6.022 0 017.229 16h-2.13a.639.639 0 01-.638-.639v-.213c0-.352.286-.638.639-.638h2.129a4.53 4.53 0 004.524-4.525A4.53 4.53 0 007.23 5.461H3.3l2.705 2.705c.29.29.29.763 0 1.054a.763.763 0 01-1.054 0L.975 5.243a.74.74 0 01-.219-.527.74.74 0 01.219-.527L4.952.21a.763.763 0 011.054 0c.29.29.29.763 0 1.054L3.301 3.97h3.928a6.022 6.022 0 016.015 6.015z","fill":"currentColor"}})])
          )
        }
      }
    